import React from 'react';
import { Box, Container, Paper, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ScratchCard from './ScratchCard';

export default function MyCoupon({ onNavigate, coupon, onClose, onRedeemed, isModal = false }) {
  const couponCode = coupon
    ? (coupon.code || coupon.couponCode || `ISORET-${coupon.tier || 'GOLD'}-${coupon.couponId || '75CASH'}`)
    : "ISORET-GOLD-75CASH";

  const rewardAmount = coupon
    ? (coupon.pricePaise ? coupon.pricePaise / 100 : coupon.cashbackAmount || coupon.rewardAmount || 75)
    : 75;

  const handleBack = () => {
    if (onClose) {
      onClose();
    } else if (onNavigate) {
      onNavigate('home');
    }
  };

  const content = (
    <Paper
      elevation={0}
      sx={{
        background: 'rgba(21, 58, 53, 0.95)',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(245, 241, 230, 0.12)',
        borderRadius: '28px',
        p: { xs: 2.5, sm: 4 },
        textAlign: 'center',
        boxShadow: '0 20px 40px rgba(0,0,0,0.6)',
        position: 'relative',
      }}
    >
      {onClose && (
        <IconButton
          onClick={onClose}
          aria-label="close popup"
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            color: 'rgba(245, 241, 230, 0.7)',
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            '&:hover': {
              color: '#F5F1E6',
              backgroundColor: 'rgba(255, 255, 255, 0.15)',
            },
            zIndex: 10,
          }}
        >
          <CloseIcon />
        </IconButton>
      )}

      {/* Standalone ScratchCard component with logic lifted & shifted */}
      <ScratchCard
        coupon={coupon}
        prize={rewardAmount}
        couponCode={couponCode}
        status={coupon?.status === 'REDEEMED' ? 'scratched' : 'unscratched'}
        onGoBack={handleBack}
        onRedeemed={onRedeemed}
      />

    </Paper>
  );

  if (isModal) {
    return content;
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: '#0F2E2B',
        color: '#F5F1E6',
        py: 8,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: `
            radial-gradient(650px 450px at 85% -10%, rgba(212,162,76,0.14), transparent 60%),
            radial-gradient(550px 450px at -10% 80%, rgba(47,143,118,0.18), transparent 60%)
          `,
          zIndex: 0,
          pointerEvents: 'none',
        },
      }}
    >
      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
        {content}
      </Container>
    </Box>
  );
}

